export default {
    excellent: 'Excellente',
    fair: 'Moyenne',
    good: 'Bonne',
    poor: 'Faible',
    'very good': 'Très bonne',
};
